function eq(value, other) {
  return value === other || value !== value && other !== other;
}

var eq_1 = eq;
export { eq_1 as e };